'use strict'

// 请求数据修改
// 递归过滤字符串类型的空格
export const trimString = function (obj) {
  if (obj && obj instanceof Object && Object.keys(obj).length > 0) {
    for (let i in obj) {
      if (typeof obj[i] === 'string') {
        obj[i] = obj[i].trim()
      } else if (obj[i] instanceof Object) {
        obj[i] = trimString(obj[i])
      }
    }
  }
  return obj
}

export default {
  trimString
}



// WEBPACK FOOTER //
// ./src/utils/common.js